import React from "react";
import "./TrustedByLeaders.css";

const TrustedByLeaders = () => {
  const companies = [
    {
      id: 1,
      name: "Madalen",
      icon: (
        <img src="/assets/images/About_page/Trustedby/Frame3.png" alt="↗" />
      ),
    },
    {
      id: 2,
      name: "Horizon",
      icon: (
        <img src="/assets/images/About_page/Trustedby/Frame2.png" alt="↗" />
      ),
    },
    {
      id: 3,
      name: "Xeno",
      icon: (
        <img src="/assets/images/About_page/Trustedby/Frame1.png" alt="↗" />
      ),
    },
    {
      id: 4,
      name: "Madalen",
      icon: (
        <img src="/assets/images/About_page/Trustedby/Frame3.png" alt="↗" />
      ),
    },
    {
      id: 5,
      name: "Horizon",
      icon: (
        <img src="/assets/images/About_page/Trustedby/Frame2.png" alt="↗" />
      ),
    },
    {
      id: 6,
      name: "Xen",
      icon: (
        <img src="/assets/images/About_page/Trustedby/Frame1.png" alt="↗" />
      ),
    },
  ];

  return (
    <div className="TrustedByLeaders-container">
      <div className="about-All">
        <h1>Trusted by Industry Leaders</h1>
        <h2>Proven Results Across Businesses</h2>
        <h4>
          From startups to enterprises, Clybourne empowers organizations to make
          informed, strategic decisions.
        </h4>
      </div>
      <div className="TrustedByLeaders-section">
        <div className="TrustedByLeaders-subcontainer">
          {companies.map((company) => (
            <div className="TrustedByLeaders-flex" key={company.id}>
              <div>{company.icon}</div>
              <p>{company.name}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TrustedByLeaders;
